import { Divider, ListItem, Skeleton, styled } from '@mui/material'

const NameSkeleton = styled(Skeleton)`
  margin-right: 13px;
`

const UsernameSkeleton = styled(Skeleton)`
  margin-right: auto;
`

const StyledDivider = styled(Divider)`
  :last-child {
    display: none;
  }
`

export function MentionMenuItemSkeleton({
  imageCaptionMode,
}: {
  imageCaptionMode?: boolean
}) {
  return (
    <>
      <ListItem
        disableGutters
        sx={{ display: 'flex', padding: '6px 15px 5px' }}
      >
        <Skeleton
          variant="circular"
          width="34px"
          height="34px"
          sx={{ backgroundColor: imageCaptionMode ? 'gray' : '#ccc' }}
        />
        <NameSkeleton
          variant="text"
          height="22px"
          width="120px"
          sx={{ backgroundColor: imageCaptionMode ? 'gray' : '#ccc' }}
        />
        <UsernameSkeleton
          variant="text"
          height="22px"
          width="90px"
          sx={{ backgroundColor: imageCaptionMode ? 'gray' : '#ccc' }}
        />
      </ListItem>

      <StyledDivider
        variant="inset"
        sx={{ borderColor: imageCaptionMode ? '#FFFFFF19' : 'inherit' }}
      />
    </>
  )
}

MentionMenuItemSkeleton.defaultProps = {
  imageCaptionMode: false,
}
